"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { WorkspaceElementType } from '@membranehq/sdk';
import { useElement } from '../element/useElement.mjs';

function useFieldMappingInstance(selector) {
  const {
    item: fieldMappingInstance,
    accessor,
    refresh,
    ...rest
  } = useElement(
    WorkspaceElementType.FieldMappingInstance,
    selector,
    (integrationApp) => selector ? integrationApp.fieldMappingInstance(selector) : void 0
  );
  async function setup() {
    await accessor?.setup();
    await refresh();
  }
  async function reset() {
    await accessor?.reset();
    await refresh();
  }
  async function openConfiguration(options) {
    return accessor?.openConfiguration(options);
  }
  return {
    fieldMappingInstance,
    accessor,
    refresh,
    setup,
    reset,
    openConfiguration,
    ...rest
  };
}

export { useFieldMappingInstance };
